package it.neckar.lizergy.model.location

import com.meistercharts.maps.RouteMapCoordinates
import it.neckar.rest.RestRequest
import kotlinx.serialization.Serializable

@Serializable
data class RouteInformationRequest(val routeMapCoordinates: RouteMapCoordinates) : RestRequest
